<template>
    <div class="delimiter" />
</template>

<script setup lang="ts">
import type { BodyVariant, DelimiterData } from '@model/editor-js/blocks';

defineOptions({
    name: 'BlockDelimiter',
});

defineProps<{
    id?: string;
    data: DelimiterData;
    variant: BodyVariant;
}>();
</script>

<style lang="pcss" scoped>
.body-renderer .delimiter {
    height: 1px;
    background: var(--av-brand-secondary-light);
    margin: 16px 0;
}
</style>
